import type { PreloadedQuery } from 'react-relay';
import DEVAI_ISSUE_VIEW_QUERY, {
	type DevaiIssueViewQuery,
} from '@jira/issue__agents-panel/src/__generated__/DevaiIssueViewQuery.graphql';
import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';

import type { RouteResource } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

export const devaiIssueViewResource: RouteResource<
	PreloadedQuery<DevaiIssueViewQuery, Record<string, unknown>>
> = createRelayResource<DevaiIssueViewQuery>({
	type: 'DEVAI_ISSUE_VIEW_DATA',
	getQuery: ({ match, query }, { tenantContext }) => {
		const issueKey = getIssueKey(match) || query?.selectedIssue || '';

		if (!issueKey || tenantContext?.isAnonymous) {
			return {
				parameters: DEVAI_ISSUE_VIEW_QUERY,
				variables: {
					cloudId: '',
					issueKey: '',
					isAiAgentSessionsPanelEnabled: false,
					issueViewRovoDevAgentsPanelEntitlementEnabled: false,
					isAssignToRovoDevActive: false,
				},
				options: { fetchPolicy: 'store-only' },
			};
		}

		const cloudId = tenantContext?.cloudId || '';

		return {
			parameters: DEVAI_ISSUE_VIEW_QUERY,
			variables: {
				cloudId,
				issueKey,
				isAiAgentSessionsPanelEnabled: fg('jira_assignable_agent_session_experience'),
				// These conditions should be included in the conditions for RovodevAgentPanel in content-items-view.tsx
				issueViewRovoDevAgentsPanelEntitlementEnabled:
					// eslint-disable-next-line jira/ff/no-preconditioning
					(fg('rovodev-in-jira-panel-is-anonymous-precondition')
						? !tenantContext?.isAnonymous
						: true) &&
					fg('boysenberry_rovodev_main_release') &&
					fg('boysenberry_enable_entitlements_check'),
				isAssignToRovoDevActive:
					// eslint-disable-next-line jira/ff/no-preconditioning
					(fg('rovodev-in-jira-panel-is-anonymous-precondition')
						? !tenantContext?.isAnonymous
						: true) &&
					fg('boysenberry_rovodev_main_release') &&
					fg('devai_assign_to_rovodev_main_release') &&
					fg('boysenberry_enable_entitlements_check'),
			},
			options: { fetchPolicy: 'store-or-network' },
		};
	},
	isBrowserOnly: false,
});
